import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';

// Данные о реализации животных продуктов
const dataSource = [
  {
    key: 1,
    animal: "Реализация молока",
    count: 1374963,
  },
  {
    key: 2,
    animal: "Реализация шерсти в физическом весе",
    count: 5653,
  },
  {
    key: 3,
    animal: "Реализация яиц",
    count: 498576,
  },
  {
    key: 4,
    animal: "Реализация мяса в убойном весе",
    count: 290732,
  },
];

const AnimalSalesChart = () => {
  return (
    <div style={{ width: '70%', height: 500, margin: '0 auto' }}>
      <h2>Реализация животных продуктов</h2>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={dataSource} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="animal" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#8884d8" name="Количество" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AnimalSalesChart;
